import './bootstrap';
import '../css/app.css';

import {
    createApp,
    h,
    ref,
}                             from 'vue';
import {
    createInertiaApp,
    router,
}                             from '@inertiajs/vue3';
import {resolvePageComponent} from 'laravel-vite-plugin/inertia-helpers';
import DateFormatting         from './Mixins/DateFormatting.js';
import Fathom                 from './Mixins/Fathom.js';
import * as Sentry            from '@sentry/vue';

import.meta.glob(
    [
        '../img/**',
    ],
);

createInertiaApp(
    {
        progress: {
            // The delay after which the progress bar will appear, in milliseconds...
            delay: 250,

            // The color of the progress bar...
            color: '#29d',

            // Whether to include the default NProgress styles...
            includeCSS: true,

            // Whether the NProgress spinner will be shown...
            showSpinner: false,
        },

        resolve: (name) => resolvePageComponent(
            `./Pages/${name}.vue`,
            import.meta.glob([
                                 './**/*.vue',
                                 '../img/**',
                             ]),
        ),

        setup({el, App, props, plugin}) {
            const vueApp = createApp({
                                         render: () => h(App, props),
                                     })
                .use(plugin)
                .provide('advertisementDesktopBannerIndex', ref(0))
                .provide('advertisementMobileBannerIndex', ref(0))
                .mixin({methods: {route}}) // Defined in the ziggy package
                .mixin(DateFormatting)
                .mixin(Fathom);

            Sentry.init({
                            app:         vueApp,
                            environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
                            dsn:         import.meta.env.VITE_SENTRY_DSN,

                            attachProps:    true,
                            logErrors:      true,
                            sendDefaultPii: true,

                            integrations: [
                                new Sentry.Replay(),
                            ],

                            // Capture Replay for 10% of all sessions,
                            // plus for 100% of sessions with an error
                            replaysSessionSampleRate: 0.1,
                            replaysOnErrorSampleRate: 1.0,
                        });

            const mountedVueApp = vueApp.mount(el);

            let lastSeenLocale = null;

            router.on('navigate', (event) => {
                if (event?.detail?.page?.props?.dogdom?.locale?.route_key) {
                    lastSeenLocale = event.detail.page.props.dogdom.locale.route_key;
                }

                if (event?.detail?.page?.props?.dogdom?.fathom?.canonical_url) {
                    mountedVueApp.trackFathomPageview(event.detail.page.props.dogdom.fathom.canonical_url);
                }
            });

            router.on('navigate', (event) => {
                try {
                    if (Sentry) {
                        const user = event?.detail?.page?.props?.dogdom?.user;

                        if (user?.id) {
                            Sentry.setUser({
                                               id:         user.id,
                                               email:      user?.email,
                                               first_name: user?.first_name,
                                               last_name:  user?.last_name,
                                           });
                        } else {
                            Sentry.setUser(null);
                        }
                    }
                } catch (error) {
                    console.error(error);
                }
            });

            router.on('before', (event) => {
                try {
                    const currentLocale = lastSeenLocale;
                    const newUrl = event.detail.visit.url;

                    // Extract the locale from the new URL (adjust the regex or split logic based on your URL structure)
                    const newLocale = newUrl.pathname.substring(1).split('/')[0]; // Assuming the locale is the first segment after the domain

                    if (currentLocale !== newLocale) {
                        console.log('Locales do not match. Redirecting to a full-page load.');

                        // Stop the Inertia navigation
                        event.preventDefault();
                        event.stopPropagation();

                        // Perform a full-page navigation
                        window.location.href = newUrl.toString();

                        return false;
                    }
                } catch (error) {
                    console.error(error);
                }
            });
        },
    });
